<template>
  <header  class="wave-header swiper-container swiper-init demo-slider-container">
    <!--
    <swiper :options="swiperOption">
      <swiper-slide style="background-image: url(http://src.thu.edu.tw/upload/news_upload/1553066367.jpg)"></swiper-slide>
    </swiper>
    -->
    <swiper-slide class="demo-slider" style="background-image: url(http://src.thu.edu.tw/upload/news_upload/1553066367.jpg)"></swiper-slide>
  </header>
</template>

<script>
  import Service from '../../service';
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        swiperOption: {
          pagination: {
           el:'.swiper-pagination'
          },
          slidesPerView: 1.1,
          centeredSlides: true,

          /* autoplay:{
            delay:3000,
            disableOnInteraction:false,
          },
          */
          spaceBetween: 10,
          loop:true,
        }
      };
    }
  };
</script>



// WEBPACK FOOTER //
// src/pages/home/header-image.vue